// extracted by mini-css-extract-plugin
export default {"fv_area":"Menu_fv_area__Ke-+S","jump_link_area":"Menu_jump_link_area__4gsfK","box_area":"Menu_box_area__UR6ZZ","box_img":"Menu_box_img__6cQRW"};